<template>
    <div class="content-wrapper container container-margin">
        <div class="row">
            <div class="col-12 content-center-aligned">
                <img :src="textLogo" class="logo-text">
            </div>
        </div>
    </div>
</template>

<script>
import Logo from "@/assets/img/sisterhood-text.svg";

export default {
    name: "Logo",
    data() {
        return {
            textLogo: Logo
        };
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../styles/config.scss";

.logo-text {
    max-width: 600px;
    height: auto;
    width: 100%;
}
</style>
